import { render, staticRenderFns } from "./TenantsTable.vue?vue&type=template&id=6aad5359&scoped=true"
import script from "./TenantsTable.vue?vue&type=script&lang=js"
export * from "./TenantsTable.vue?vue&type=script&lang=js"
import style0 from "./TenantsTable.vue?vue&type=style&index=0&id=6aad5359&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aad5359",
  null
  
)

export default component.exports